module.exports = __webpack_public_path__ + "img/menu3.23cf5599.png";